import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Input } from '@ui/components/Input'
import { Modal } from '@ui/components/Modal'

interface Props {
  handleRecoveryCode(recoveryCode: string): void
}

export const RecoveryCodeModal: BaseModalType<Props> = (props) => {
  const { handleRecoveryCode, close } = props

  const { t } = useTranslation()
  const [recoveryCode, setRecoveryCode] = useState('')

  return (
    <Modal>
      <Modal.Header>{t('TwoFactorAuth.Enter your recovery code')}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Text>
          {t('TwoFactorAuth.We provided you with recovery codes when you first enabled 2FA')}
        </Modal.Body.Text>
        <Modal.Body.Text>
          {t('TwoFactorAuth.Use one of your Recovery codes to access Client Area')}
        </Modal.Body.Text>
        <Input
          value={recoveryCode}
          fullWidth
          onChange={(e) => setRecoveryCode(e.target.value)}
          type='text'
          label={t('TwoFactorAuth.Recovery code')}
        />
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('Cancel')}</Modal.Footer.Secondary>
        <Modal.Footer.Primary onClick={() => handleRecoveryCode(recoveryCode)}>
          {t('Confirm')}
        </Modal.Footer.Primary>
      </Modal.Footer>
    </Modal>
  )
}
